import { mergeConfig, type UserConfig } from "vite-plus";
import type { TsdownInputOption } from "vite-plus/pack";

import { fmtPreset } from "./fmt";
import { lintPreset } from "./lint";
import { packPreset } from "./pack";

export interface LibOptions {
  /** Entry preset (`"index"`, `"shallow"`, `"all"`) or custom tsdown input. */
  entry?: TsdownInputOption;
  /** Dependencies to bundle instead of externalizing (`pack.deps.onlyBundle`). */
  inlineDeps?: (string | RegExp)[];
}

/** Vite+ config for a universal (neutral platform) TypeScript library. */
export function lib(
  { entry = "index", inlineDeps = [] }: LibOptions = {},
  overrides: UserConfig = {},
): UserConfig {
  return mergeConfig(
    {
      pack: packPreset({ entry, inlineDeps }),
      lint: lintPreset(),
      fmt: fmtPreset(),
    },
    overrides,
  );
}

/** Like {@link lib} with `pack.platform` set to `node`. */
export function nodeLib(options: LibOptions = {}, overrides: UserConfig = {}): UserConfig {
  return lib(
    options,
    mergeConfig(
      {
        pack: {
          platform: "node",
        },
      },
      overrides,
    ),
  );
}
